/**
 * Filtr formatujący wartość boolean
 *
 * @export
 * @param {boolean} item
 * @returns
 */
export function boolean(item: boolean) {
  return item ? 'Tak' : 'Nie';
}
